import React from 'react';
import { Feature } from '@loyalty/shared-common';
import { RuleAttributes, RuleType } from '@loyalty/shared-common/rule-api-client';
import {
  BurningRuleFormValue,
  attributesToFormValue,
  burningRulesForm,
  formValueToAttributes,
} from './form';
import { BurningRulePanels } from './BurningRulePanels';
import { RuleModal } from '../rules/components/RuleModal';
import { useCurrencies } from '../currency/CurrenciesContext';
import { useFeatures } from '../features/FeaturesContext';
import { useProgram } from '../loyalty/ProgramContext';
import { useRewards } from '../rewards/RewardsContext';

export interface BurningRuleModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  rule?: RuleAttributes;
}

export function BurningRuleModal({ isOpen, setIsOpen, rule }: BurningRuleModalProps) {
  const { features } = useFeatures();
  const { rewards } = useRewards();
  const { currencies } = useCurrencies();
  const { program } = useProgram();

  const { write: canEdit } = features[Feature.BURNING_RULE];

  return (
    <RuleModal<BurningRuleFormValue>
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      rule={rule}
      formValueToRuleInput={formValueToAttributes}
      formSchema={burningRulesForm}
      getResetValue={() =>
        attributesToFormValue(rule, currencies, rewards, program.languages, program.timezone)
      }
      canEdit={canEdit}
      ruleType={RuleType.BURN}
    >
      <BurningRulePanels />
    </RuleModal>
  );
}
